import { useContext } from 'react';
import { SubscriptionDetailsContext } from '../context/SubscriptionDetailsContext.js';

/**
 * Custom hook to normalize the subscription status from context.
 * @returns {string} - The normalized subscription status: 'active' or 'not active'.
 */
export default function useNormalizedSubscriptionStatus() {
  const subscriptionDetails = useContext(SubscriptionDetailsContext);

  if (!subscriptionDetails) return 'not active';

  const { isSubscribed } = subscriptionDetails;

  // User is active if subscribed and plan exists (autoRenewal true or false)
  if (isSubscribed) {
    return 'active';
  }

  // Everything else (new user, suspended, not eligible) → not active
  return 'not active';
}
